<template>
  <div class="address">
    <Head :title="title"></Head>
    <div class="address_bottom">
      <div
        class="list"
        v-for="(item, index) in addressList"
        :key="item.id"
        @click="han(item, index)"
      >
        <div class="head">
          <div>{{ item.consignee.slice(0, 1) }}</div>
        </div>
        <div class="information">
          <p class="name">
            <span>{{ item.consignee }}</span>
            <span>{{
              item.phone.replace(/(\d{3})\d{6}(\d{2})/, "$1****$2")
            }}</span>
            <span v-if="item.isDefault === 1">默认</span>
          </p>
          <p class="addresss">
            <span>{{ item.provinceName }}</span>
            <span>{{ item.cityName }}{{ item.districtName }}</span>
            <span>{{ item.detailAddress }}</span>
          </p>
        </div>
        <div class="edit" @click.stop="edit(item.id)">
          <img src="@/assets/mylogin/edit.png" alt="" />
        </div>
      </div>
    </div>
    <div class="address_page">
      <van-button type="primary" block class="obt" @click="goNewaddress">
        <img
          style="
            width: 17px;
            height: 17px;
            margin-right: 10px;
            margin-top: -4px;
            vertical-align: middle;
          "
          src="../../../../assets/mylogin/push.png"
          alt=""
        />
        <div style="display: inline-block">新增收货地址</div>
      </van-button>
    </div>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
import { Toast } from "vant";

export default {
  name: "address",
  data() {
    return {
      addressList: [],
      title: "收货地址",
      dizhi: "",
    };
  },
  components: {
    Head,
  },
  created() {
    this.getByUserList();
  },
  methods: {
    goNewaddress() {
      if (this.addressList.length === 10) {
        Toast("收货地址最多10条");
      } else {
        this.$router.push("newaddress");
      }
    },
    async getByUserList() {
      let data = JSON.parse(sessionStorage.getItem("userInfo"));
      const res = await this.$apis.addressServe.getByUserList({
        userId: data.user.id,
      });
      this.addressList = res.data;
    },
    edit(item) {
      this.$router.push({ path: "/editaddress", query: { item } });
    },
    // 跳转回商品详情页中确认订单页，
    han(item) {
      if (this.$route.query.isFrom) {
        sessionStorage.setItem("Address", JSON.stringify(item));
        window.history.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.address {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;

  .address_bottom {
    width: 94%;
    margin: 12px auto 65px;
    border-radius: 8px 8px 8px 8px;
    background: #fff;

    .list {
      width: 100%;
      height: 94px;
      display: flex;
      overflow: hidden;
      border-bottom: 1px solid #f5f5f5;

      .head {
        width: 41px;
        height: 41px;
        background: #e9efff;
        border-radius: 50%;
        opacity: 1;
        margin-left: 15px;
        vertical-align: middle;
        margin-top: 30px;
        font-size: 13px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        color: #4979f1;
        text-align: center;

        div {
          margin-top: 10px;
        }
      }

      .information {
        width: 230px;

        .name {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          margin-top: 27px;
          display: flex;
          justify-content: space-between;

          span {
            font-size: 16px;
            font-family: PingFangSC-Heavy, PingFang SC;
            font-weight: 800;
            color: #333333;

            &:nth-child(1) {
              display: block;
              margin-left: 13px;
              margin-right: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &:nth-child(3) {
              display: inline-block;
              width: 33px;
              height: 19px;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #4979f1;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #4979f1;
              line-height: 19px;
              padding: 0px 0px 0px 4px;
              margin-left: 11px;
              flex-shrink: 0;
            }
          }
        }

        .addresss {
          margin-top: 5px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;

          span {
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
            margin-left: 12px;

            &:nth-child(2) {
              margin-left: 5px;
            }

            &:nth-child(3) {
              margin-left: 5px;
            }
          }
        }
      }

      .edit {
        overflow: hidden;
        flex: 1;

        img {
          width: 17px;
          height: 18px;
          margin-top: 40px;
          float: right;
          margin-right: 20px;
        }
      }
    }
  }

  .address_page {
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0px;
    background: #fff;

    .obt {
      margin: 5px auto;
      width: 94%;
      background: #4979f1;
      border-radius: 21px 21px 21px 21px;
      border: none;
    }
  }
}
</style>
